import "./App.css";
import { Landing } from "./components/Landing/Landing";
import Header from "./layouts/Header/Header";

function App() {
  return (
    <div className="App">
      {/* <Header /> */}
      <Landing />
    </div>
  );
}

export default App;
